import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class VehicleClassesDisplayListComponent implements IController {

  ids: any;
  isRow: any;
  rowLimit: any;

  onChange: Function;

  private displayItems: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.rowLimit) {
      this.rowLimit = 10;
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }
}

angular
  .module('bringoz.admin.vehicles')
  .component('vehicleClassesDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./vehicle-classes-display-list.html').default,
    controller: VehicleClassesDisplayListComponent
  });
